
export class SelectableItem<T>{

    constructor(public item: T, public isSelected: boolean = false) {
    }
}
